module.exports = __webpack_public_path__ + "img/40_78.7d8358b2.png";